import React from "react";
import "../../shared/styles/shared-styles.css";

const EditSuccessModal = (props) => {
  const { bodyText, title } = props;
  return (
    <div data-testid="edit-success-modal" className="shift-modal-container">
      <div className="modal-body">
        <img src="images/roster/edit-shift-success.svg" />
        <span className="modal-body-header">{title}</span>
        <span data-testid="edit-success-body" className="modal-body-description">
          {bodyText}
        </span>
        <button
          data-testid="edit-success-cancel"
          className="modal-button modal-confirm-button"
          onClick={props.cancel}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default EditSuccessModal;
